import { BarChart } from "../Chart/BarChart";
import { LineChart } from "../Chart/LineChart";
import classes from "./Dashboard.module.css";
import Hexagon from "react-hexagon";
import { useContext, useEffect, useState } from "react";
import authContext from "../../../AuthContext/authContext";
import Loader from "../Common/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import appActions from "../../../ReduxStore/appDataSlice";
import PieChart from "../Chart/PieChart";
import UniqueVisitor from "../Chart/UniqueVisitor";
import DepartmentWise from "../Chart/DepartmentWise";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Dashboard = ({
  initialData,
  setCompanyId,
  setFrequency,
  companyList,
  locationList,
  setSelectedLocation,
  isLoading,
}) => {
  const {
    currentMonthVisitors,
    digipassGenerated,
    digipassRejected,
    lastMonthVisitors,
    smsCount,
    visitorCount,
    companyCount,
    repeatedVisitorNumber,
    uniqueVisitorNumber,
    subscriptionEndDate,
    ppoCount,
  } = initialData;

  const navigate = useNavigate();

  const ctx = useContext(authContext);
  const userType = ctx.userData.user_type;
  const [showWarning, setShowWarning] = useState(false);
  
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  let activePPU = false;
  activePPU = activeCompany?.ppoData?.find((item) => item?.isActive === true);
 // alert(activePPU);
  let showCompany = userType == "admin" || userType == "subadmin";
  let showLocations = !(userType === "location" || userType === "company");
  // console.log(initialData,"initialData");
  // console.log(initialData.passAllocations,"ppoCount");
  
  // useEffect(() => {
  //   if (showCompany && companyList.length > 0) {
  //     setCompanyId(companyList[0]["_id"]);
  //   }
  // }, []);
  
  useEffect(() => {
   //console.log(initialData?.totalAvailablePasses);
    //console.log(activePPU,"activePPU");
    //console.log(initialData?.totalAvailablePasses);
    //&& activePPU
    if (initialData?.totalAvailablePasses < 75 ) {
      setShowWarning(true);
    } else {
      setShowWarning(false);
    }
    console.log(showWarning);
  }, [initialData?.totalAvailablePasses]);
  let companyArr = [];

  for (let i = 0; i < companyCount; i++) {
    companyArr.push(0);
  }

  console.log("companyArr", companyArr);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(
  //     appActions.setBarChartPayload({ companyId: companyList[0]["_id"] })
  //   );
  //   localStorage.setItem(
  //     "barChartPayload",
  //     JSON.stringify({ companyId: companyList[0]["_id"] })
  //   );
  // }, []);

  const handleFrequency = (e) => {
    setFrequency(e.target.value);
    dispatch(appActions.setBarChartFreqency(e.target.value));
  };
  return (
    

    <>

    <div className={classes.dashboardCont}>
      { 
      
      //showWarning === true && (activePPU == true || userType) &&(
      (initialData?.totalAvailablePasses > 0 && initialData?.totalAvailablePasses < 75) &&(
        <>
        <div style={{
          backgroundColor: "red",
          color: "white",
          textAlign: "center",
          padding: "10px",
          fontSize: "16px",
          animation: "blinker 2s linear infinite",
        }}>
            ⚠️ Low Passes: {initialData?.totalAvailablePasses}  remaining {showWarning}
          </div>
          <style>
          {`
            @keyframes blinker {
              50% { opacity: 0; }
            }
          `}
        </style>
        </>
          
      )}
      <div className={classes.header}>
        <div>
          <h2>Dashboard</h2>
        </div>
        <div className={classes.rightCont} style={{ width: "70%" }}>
          {/* <select>
            <option>DF Technology</option>
          </select>
          <select>
            <option>Monthlys</option>
          </select> */}
          {subscriptionEndDate && (
            <div className={classes.renew}>
              Renew date:{" "}
              <strong>
                {" "}
                {moment.utc(subscriptionEndDate).local().format("DD MMMM YYYY")}
              </strong>
            </div>
          )}
          <div className={classes.dowpDown}>
            {showCompany && companyList.length > 0 && (
              <select
                class="form-select mr-2 mt-2"
                aria-label="Default select example"
                onChange={(e) => {
                  setCompanyId(e.target.value);
                  dispatch(
                    appActions.setBarChartPayload({ companyId: e.target.value })
                  );
                  localStorage.setItem(
                    "barChartPayload",
                    JSON.stringify({ companyId: e.target.value })
                  );

                  //reset location
                  dispatch(appActions.setChartLocation({ locationId: "" }));
                  localStorage.setItem(
                    "chartLocation",
                    JSON.stringify({ locationId: "" })
                  );
                  document.getElementById("locationlist").value = "";
                }}
              >
                <option selected value={companyList[0]["_id"]}>
                  {companyList[0]["name"]}
                </option>
                {companyList.map((company, index) => {
                  if (index !== 0) {
                    return (
                      <option key={index} value={company._id}>
                        {company.name}
                      </option>
                    );
                  }
                })}
              </select>
            )}

            {showLocations && locationList.length > 0 && (
              <select
                class="form-select mr-2 mt-2"
                aria-label="Default select example"
                id="locationlist"
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  dispatch(
                    appActions.setChartLocation({ locationId: e.target.value })
                  );
                  localStorage.setItem(
                    "chartLocation",
                    JSON.stringify({ locationId: e.target.value })
                  );
                }}
              >
                <option selected value="">
                  All
                </option>
                {locationList.map((locations, index) => {
                  return (
                    <option key={index} value={locations._id}>
                      {locations.location}
                    </option>
                  );
                })}
              </select>
            )}

            <select
              class="form-select mr-2 mt-2"
              aria-label="Default select example"
              onChange={handleFrequency}
            >
              <option value={7} selected>
                7 days
              </option>
              <option value={30}>1 Month</option>
              <option value={90}>3 Months</option>
              <option value={365}>1 Year</option>
            </select>
          </div>
        </div>
      </div>

      {isLoading ? (
        <section class="container">
          {window.screen.width > 480 && showCompany && (
            <div
              className={`row ${classes.NewCompany}`}
              onClick={() => navigate("/dashboard/companyOnboarded")}
              style={{ cursor: "pointer" }}
            >
              <h2>Companies Onboarded - {companyCount}</h2>
              {/* <ul className={classes.list}>
                {Array.from({ length: companyCount }, () => (
                  <li className={classes.listItem}></li>
                ))}

                {Array.from({ length: 100 }, () => (
                  <li
                    className={classes.listItem}
                    style={{ border: "4px solid #fff" }}
                  ></li>
                ))}
              </ul> */}
            </div>
          )}

          {window.screen.width < 480 && (
            <div
              className="row"
              onClick={() => navigate("/dashboard/companyOnboarded")}
              style={{ cursor: "pointer" }}
            >
              <div className={`col m-3 ${classes.card} ${classes.card1}`}>
                <h1>{companyCount}</h1>
                <h2>
                  Companies <br />
                  Onboarded
                </h2>
              </div>
            </div>
          )}

          <div className="row">
            {/* {showCompany && (
              <div className={`col m-3 ${classes.card}`}>
                <h2>New company</h2>
                <h2>{companyCount}</h2>
              </div>
            )} */}

            <div className={`col m-3 ${classes.card} ${classes.card1}`}>
              <h1>{visitorCount}</h1>
              <h2>
                Total <br />
                Visitors
              </h2>
            </div>

            <div className={`col m-3 ${classes.card} ${classes.card2}`}>
              <h1>{uniqueVisitorNumber}</h1>
              <h2>
                Unique <br /> Visitors
              </h2>
            </div>

            <div className={`col m-3 ${classes.card} ${classes.card3}`}>
              <h1>{repeatedVisitorNumber}</h1>
              <h2>
                Repeat <br />
                Visitors
              </h2>
            </div>
          </div>

          <div className="row">
            <div className={`col m-3 ${classes.card} ${classes.card4}`}>
              <h1>{digipassGenerated}</h1>
              <h2>
                Pass <br /> Generated
              </h2>
            </div>

            <div className={`col m-3 ${classes.card} ${classes.card5}`}>
              <h1>{digipassRejected}</h1>
              <h2>
                Pass <br /> Rejected
              </h2>
            </div>

            <div className={`col m-3 ${classes.card} ${classes.card6}`}>
              <h1>{smsCount}</h1>
              <h2>
                Total SMS <br /> Pushed
              </h2>
            </div>
          </div>

          {/* Pending Passes Section */}
          <div className="row">
            {/* Pending Passes Card */}
            <div className={`col m-3 ${classes.card} ${classes.card7}`}>
              <h1>{String(initialData.pendingPasses||0)}</h1>
              <p style={{fontSize: '1.7rem', fontWeight: '650', margin: '0.5rem 0 0', lineHeight: '1.4'}}>
                Pending <br /> Passes
              </p>
            </div>

            {/* Delegate Passes Card */}
            <div className={`col m-3 ${classes.card} ${classes.card8}`}>
              <h1>{String(initialData.specialPasses?.delegate || 0)}</h1>
              <p style={{fontSize: '1.7rem', fontWeight: '650', margin: '0.5rem 0 0', lineHeight: '1.4'}}>
                Delegate <br /> Passes
              </p>
            </div>

            {/* Vendor Passes Card */}
            <div className={`col m-3 ${classes.card} ${classes.card9}`}>
              <h1>{String(initialData.specialPasses?.vendor || 0)}</h1>
              <p style={{fontSize: '1.7rem', fontWeight: '650', margin: '0.5rem 0 0', lineHeight: '1.4'}}>
                Vendor <br /> Passes
              </p>
            </div>
          </div>

          {initialData.ppoStats !=null && (
            <>
              <div className="row mb-1">
                <div className="col-12">
                    <div className={`card ${classes.passUsageCard} h-100`}>
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <div>
                            <h6 className="card-title mb-1 text-uppercase text-muted fw-semibold small">Pass Usage</h6>
                            <h2 className="mb-0 fw-bold">
                              <span className="text-primary">{initialData?.totalCreatedPasses || 0}</span> / {initialData?.ppoStats?.totalPasses || 0}
                              <span className="ms-2 text-muted fs-6 fw-normal">passes used</span>
                            </h2>
                          </div>
                          {/* <div className={`${classes['icon-container']}`}>
                            <i className="bi bi-ticket-perforated"></i>
                          </div> */}
                        </div>
                        
                        <div className="mb-4">
                          <div className="d-flex justify-content-between mb-2">
                            <small className="text-muted fw-medium">0%</small>
                            <small className="text-muted fw-medium">100%</small>
                          </div>
                          <div className="progress">
                            <div 
                              className="progress-bar" 
                              role="progressbar" 
                              style={{
                                width: `${Math.min(100, ((initialData?.totalCreatedPasses || 0) / (initialData?.ppoStats?.totalPasses || 1) * 100))}%`,
                                background: 'linear-gradient(90deg, #4e73df 0%, #224abe 100%)',
                              }}
                              aria-valuenow={initialData?.totalCreatedPasses || 0}
                              aria-valuemin="0"
                              aria-valuemax={initialData?.ppoStats?.totalPasses || 1}
                            ></div>
                          </div>
                        </div>
                        
                        <div className="d-flex justify-content-between align-items-center">
                          <span className={` d-inline-flex align-items-center`}>
                           <i className="bi bi-activity me-2"></i>
                            {Math.round((initialData?.totalCreatedPasses || 0) / (initialData?.ppoStats?.totalPasses || 1) * 100) || 0}% Utilized
                          </span>
                           
                          <div className=" text-end">
                            <small className="text-muted fw-medium">
                              <i className="bi bi-ticket-perforated me-1"></i>
                              {initialData?.ppoStats?.totalPasses - (initialData?.totalCreatedPasses || 0)} passes available
                            </small>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              {initialData.passAllocations && initialData.passAllocations.length > 0 && (
                <div className="col-12 mt-3">
                  <div className="card">
                    <div className={`card-header ${classes.header8} text-white`}>
                      <h5 className="mb-0">Pass Allocations</h5>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Location</th>
                              <th>Total Allocated</th>
                              <th>Available</th>
                            </tr>
                          </thead>
                          <tbody>
                            {initialData.passAllocations.map((allocation, index) => (
                              <tr key={allocation._id}>
                                <td>{allocation.name}</td>
                                <td>{allocation.email}</td>
                                <td>{allocation.location}</td>
                                <td>{allocation.totalAllocated}</td>
                                <td>{allocation.available}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          <div className="row">
            <div className={`col card text-bg-primary m-3 ${classes.pieCard}`}>
              <div className={`card-header text-center ${classes.header8}`}>
                Visitor Data
              </div>
              <div
                class={`card-body  ${classes.dog6}`}
                style={{ width: "100%", margin: "auto" }}
              >
                <PieChart
                  currentMonthVisitors={currentMonthVisitors}
                  lastMonthVisitors={lastMonthVisitors}
                />
              </div>
            </div>

            <div className={`col card text-bg-primary m-3 ${classes.pieCard}`}>
              <div className={`card-header text-center ${classes.header8}`}>
                Department wise visitors
              </div>
              <div
                class={`card-body  ${classes.dog6}`}
                style={{ width: "100%", margin: "auto" }}
              >
                <DepartmentWise />
              </div>
            </div>
          </div>

          <div className={` ${classes.lineChart}`}>
            <div>
              <h2 className="text-center">Visitors</h2>
              <div className={classes.lineChartDiv}>
                <LineChart />
              </div>
            </div>
          </div>

          {/* <div className={` ${classes.lineChart} ${classes.barChart}`}>
            <div>
              <h2 className="text-center">Department Wise Visitors</h2>
              <div className={classes.lineChartDiv}>
                <BarChart />
              </div>
            </div>
          </div> */}
        </section>
      ) : (
        <Loader centerLoader={"centerLoader"} />
      )}
    </div>
    </>
  );
};

export default Dashboard;
